<template>
    <v-chip class="offer-support-steps-chip d-flex justify-center">
        <slot></slot>
    </v-chip>
</template>